module.exports = __webpack_public_path__ + "static/img/healthy-ear.5eb59c57.png";